import React from 'react';

import API from '../API';
import { Apify } from '../Apify';
import { connect } from 'react-redux';
import { T } from '../traks';

var CollectionChecker = (props) => {
	const change = (e) => {
		API.post("/a/set_stock_on_active_collection", {set: e.target.checked ? 1 : 0, exchange: props.exchange, ticker: props.ticker}, () => {
			props.ctl.reload();
		});
	};
	return (
		<div className="pt-2">
			<label htmlFor="shortlist_checkbox">
			<input type="checkbox" id="shortlist_checkbox" checked={props.in_collection} onChange={change}/>
			<span className="pr-2"/>
			<T>Added to shortlist</T>
			</label>
		</div>
	);
}
CollectionChecker = Apify("/a/in_active_collection")
	.with_query_from_props(props => ({exchange: props.exchange, ticker: props.ticker}))
	.with_response_prop("in_collection")
	.with_ctl_prop()
	.wrap(CollectionChecker);
export default connect(
	(state) => ({me: state.me})
)((props) => props.me && <CollectionChecker {...props}/>);



// WEBPACK FOOTER //
// ./src/c/CollectionChecker.js